import close from '../assets/images/allicons/close.svg'
import addaudio from '../assets/images/newpost/addaudio.svg'
import addcalendar from '../assets/images/newpost/addcalendar.svg'
import addcoin from '../assets/images/newpost/addcoin.svg'
import addimg from '../assets/images/newpost/addimg.svg'
import addmessage from '../assets/images/newpost/addmessage.svg'
import addpost from '../assets/images/newpost/addpost.svg'
import addstory from '../assets/images/newpost/addstory.svg'
import addtwitter from '../assets/images/newpost/addtwitter.svg'
import addvid from '../assets/images/newpost/addvid.svg'
import editpost from '../assets/images/newpost/editpost.svg'
import group from '../assets/images/newpost/group.svg'
import note from '../assets/images/newpost/note.svg'
import pauseaudio from '../assets/images/newpost/pauseaudio.svg'
import plus from '../assets/images/newpost/plus.svg'

export const Icons = {
    addaudio,
    pauseaudio,
    addcalendar,
    addcoin,
    addimg,
    addmessage,
    addpost,
    addstory,
    addtwitter,
    addvid,
    editpost,
    plus,
    note,
    group,
    close
}
